import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { LabPassDataSourceService } from './lab-pass.datasource.service';
import { ILabomatesResponse } from '../lab-pass-types';
import { StorageService } from '@shared/core/services/storage.service';
import { filter, map, takeUntil, tap, switchMap } from 'rxjs/operators';
import { BreadcrumbItem } from 'src/app/shared/modules/breadcrumb/types/breadcrumbItem';
import { ModalSize } from '@shared/enums/modal-sizes';
import { ModalService } from '@shared/services/modal/modal.service';

@Injectable()
export class LabPassRepositoryService implements OnDestroy {
  constructor(
    private dataSource: LabPassDataSourceService,
    private storage: StorageService,
    private modal: ModalService
  ) {
    this.getLabomates();
  }

  labomates$ = new BehaviorSubject<ILabomatesResponse[] | null>(null);
  city$ = this.storage.cityName$;
  private hasHelixExpress$ = this.city$.pipe(
    map((city) => city?.toLowerCase() === 'санкт-петербург')
  );
  breadcrumbs: BreadcrumbItem[] = [
    { href: '/', text: 'Главная' },
    { href: '', text: 'Helix Express' },
  ];

  private ngUnsubscribe$ = new Subject<void>();

  private getLabomates(): void {
    this.hasHelixExpress$
      .pipe(
        tap((hasHelixExpress) => {
          if (!hasHelixExpress) {
            this.labomates$.next([]);
          }
        }),
        filter((hasHelixExpress) => hasHelixExpress),
        switchMap(() => this.dataSource.getLabomates()),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((labomates) => {
        this.labomates$.next(labomates);
      });
  }

  openModalSuccess(): void {
    this.modal.createSuccess(
      'Ваше сообщение отправлено!',
      'Наши менеджеры свяжутся с вами по указанным контактным данным.',
      ModalSize.Form,
      5
    );
  }

  openModalError(message: string): void {
    this.modal.createError(message);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
